module.exports = "/pages/google/Common/Hotelslabo/Detail/first_view_background.jpg";